import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeoJsonUtilityService {
  public static getNormalizedGeometriesOrFeaturesFromGeoJson(geometry: any): any[] {
    const geometries = [];
    const arrayStackToFlatten = [];
    arrayStackToFlatten.push(geometry);

    // find geometries inside collections
    while (arrayStackToFlatten.length > 0) {
      // Pop geometry
      const arr = arrayStackToFlatten.pop();
      if (!arr) {
        continue;
      }
      if (!arr.type) {
        if (Array.isArray(arr) && arr.length > 0) {
          arr.forEach(a => arrayStackToFlatten.push(a));
        }

        continue;
      }
      // Explore Geomtries, extracting core
      const type = arr.type.toLowerCase();
      if (type === 'featurecollection' && arr.features && arr.features.length > 0) {
        arr.features.forEach(element => {
          arrayStackToFlatten.unshift(element);
        });
        continue;
      }
      if (type === 'featurecollection') {
        continue;
      }
      if (type === 'feature' && arr.geometry?.type === 'GeometryCollection') {
        const geoFeature = { ...arr };
        delete geoFeature.geometries;
        if (arr.geometry.geometries && arr.geometry.geometries.length > 0) {
          arr.geometry.geometries.forEach(element => {
            if (!element) {
              return;
            }
            arrayStackToFlatten.unshift({ ...geoFeature, geometry: element });
          });
        } else {
          arrayStackToFlatten.unshift({ ...geoFeature, geometry: null });
        }
        continue;
      }
      if (type === 'geometrycollection') {
        if (arr.geometries && arr.geometries.length > 0) {
          arr.geometries.forEach(element => {
            if (!element) {
              return;
            }
            arrayStackToFlatten.unshift(element);
          });
        }
        continue;
      }
      if (type === 'multipoint' && arr.coordinates && arr.coordinates.length > 0) {
        arr.coordinates.forEach(element => {
          if (!element) {
            return;
          }
          geometries.push({
            type: 'Point',
            coordinates: element
          });
        });
        continue;
      }
      if (type === 'multilinestring' && arr.coordinates && arr.coordinates.length > 0) {
        arr.coordinates.forEach(element => {
          if (!element) {
            return;
          }
          geometries.push({
            type: 'LineString',
            coordinates: element
          });
        });
        continue;
      }
      if (type === 'multipolygon' && arr.coordinates && arr.coordinates.length > 0) {
        arr.coordinates.forEach(element => {
          if (!element) {
            return;
          }
          geometries.push({
            type: 'Polygon',
            coordinates: element
          });
        });
        continue;
      }
      // only extract feature geometries when this is a feature with a geometry collection
      // this is because we need to preserve features that are circles, or have other shape meta data
      if (type === 'feature' && arr.geometry?.type === 'geometrycollection') {
        arrayStackToFlatten.unshift(arr.geometry);
        continue;
      }
      // non-(featureCollection, Feature with GeometryCollection, Multi-xxx)
      geometries.push(arr);
    }

    // Rewind any non-compliant polygon rings
    geometries.forEach(fg => {
      const g = fg?.type === 'Feature' ? fg.geometry : fg;
      if (!g) {
        return;
      }
      if (g.type === 'Polygon') {
        GeoJsonUtilityService.rewindRings(g.coordinates as [number, number][][], true);
      }
    });
    return geometries;
  }

  private static rewindRings(rings: [number, number][][], outer: boolean = true) {
    if (rings.length === 0) return;

    GeoJsonUtilityService.rewindRing(rings[0], outer);
    for (let i = 1; i < rings.length; i++) {
      GeoJsonUtilityService.rewindRing(rings[i], !outer);
    }
  }

  private static rewindRing(ring: [number, number][], outer: boolean = true) {
    let area = 0,
      err = 0;
    for (let i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
      const k = (ring[i][0] - ring[j][0]) * (ring[j][1] + ring[i][1]);
      const m = area + k;
      err += Math.abs(area) >= Math.abs(k) ? area - m + k : k - m + area;
      area = m;
    }
    if (area + err >= 0 !== !!outer) ring.reverse();
  }
}
